export const WorkflowChecklistItemStates = Object.freeze({
    Completed: 'completed',
    Current: 'current',
    Available: 'available',
    Locked: 'locked'
});

export type WorkflowChecklistItemState = (typeof WorkflowChecklistItemStates)[keyof typeof WorkflowChecklistItemStates];
